import * as Sentry from "@sentry/react";

const SENTRY_TAG_CLIENT_NAME_SLUG = 'client_name';

export const initSentry = (appConfig) => {

  const packageJson = require ('../../package.json');

  // cambiar en ese if NODE_ENV === a 'development' para probar en desarrollo, si no no funcionara
  if (process.env.NODE_ENV === 'production' && process.env.SENTRY_DSN) {
    if (appConfig.SENTRY_TAG_CLIENT_NAME) {
      Sentry.setTag(SENTRY_TAG_CLIENT_NAME_SLUG, appConfig.SENTRY_TAG_CLIENT_NAME)
    }
    Sentry.init({
      dsn: process.env.SENTRY_DSN,
      release: packageJson.version.replace('-', '.')
    });
  }
  
}
